import "./App.scss";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from './components/common/HorizontalNavbarCustom'
import Footer from "./components/common/Footer";
import AppRoutes from "./routes/Routes";
import SettingsPanel from "./components/common/SettingsPanel";

function App() {
  const location = useLocation();
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);

  useEffect(() => {
    const fullPageLayoutRoutes = [
      "/user-pages/login",
      "/user-pages/login-2",
      "/user-pages/register",
      "/user-pages/register-2",
      "/user-pages/lock-screen",
      "/error-pages/404",
      "/error-pages/500",
      "/general-pages/landing",
    ];
    setIsFullPageLayout(fullPageLayoutRoutes.includes(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    const pageBodyWrapper = document.querySelector(".page-body-wrapper");
    if (isFullPageLayout) {
      pageBodyWrapper.classList.add("full-page-wrapper");
    } else {
      pageBodyWrapper.classList.remove("full-page-wrapper");
    }
  }, [isFullPageLayout]);

  useEffect(() => {
    const body = document.querySelector("body");
    if (location.pathname === "/rtl") {
      body.classList.add("rtl");
    } else {
      body.classList.remove("rtl");
    }
  }, [location.pathname]);


  return (
    <div className="container-scroller">
        {!isFullPageLayout && <Header />}
      <div className="container-fluid page-body-wrapper">
        <div className="main-panel">
          <div className="content-wrapper">
            <AppRoutes />
            {!isFullPageLayout && <SettingsPanel/>}
          </div>
          {!isFullPageLayout && <Footer />}
        </div>
      </div>
    </div>
  );
}

export default App;
